import { isNative } from '../common/helpers/isNative'

export const websiteUrl = 'https://yumuuv.com'
export const appDomain = window.location.host && !isNative() ? window.location.origin : 'https://app.yumuuv.com'

const getApiDomain = () => {
  const href = window.location.href
  let domain = 'https://app-api.yumuuv.com'

  if (!isNative()) {
    if (href.includes('prelive') || href.includes('staging')) {
      domain = `https://app-api.staging.yumuuv.com`
    } else if (href.includes('localhost')) {
      domain = `http://localhost:8080`
    }
  }

  // TODO: REMOVE
  // domain = 'https://app-api.staging.yumuuv.com'
  // domain = 'https://47b5-145-14-30-246.ngrok-free.app'

  return domain
}
export const apiDomain = getApiDomain()
export const isDev =
  apiDomain.includes('localhost') ||
  apiDomain.includes('prelive.yumuuv.com') ||
  apiDomain.includes('staging.yumuuv.com') ||
  apiDomain.includes('ngrok.io') ||
  apiDomain.includes('ngrok-free.app')

export default (apiSuffix: string) => {
  return `${apiDomain}/api${apiSuffix}`
}
